import React, {Component} from 'react';
import axios from "axios";

import classes from './PatternConstraintsInput.module.css';
import apiUrl from "../../../shared/config";
import NewPatternConstraint from "../NewPatternConstraint/NewPatternConstraint";
import PatternConstraintInput from "../../UI/PatternConstraintInput/PatternConstraintInput";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

class PatternConstraintsInput extends Component  {
    state = {
        pattern_constraints: [],
        selected_pattern_constraints: [],
        new_pattern_constraint: false
    };

    componentDidMount() {
        if (this.state.pattern_constraints !== []) {
            axios.get(apiUrl +'PatternConstraints/getPatternConstraints')
                .then(response => {
                    this.setState({pattern_constraints: response.data});
                });
        }
        this.setState({selected_pattern_constraints: this.props.patternConstraints});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.patternConstraints !== this.props.patternConstraints) {
            this.setState({selected_pattern_constraints: this.props.patternConstraints})
        }
    }

    newPatternConstraintToggle = () => {
        this.setState({new_pattern_constraint: !this.state.new_pattern_constraint});
    };

    newPatternConstraintsHandler = (new_pattern_constraint_add) => {
        this.props.patternConstraintsUpdate(
            [...this.state.selected_pattern_constraints, new_pattern_constraint_add].map((constraint) => {
                return {value: constraint.constraint_id, label: constraint.constraint_title, description: constraint.constraint_description}
            })
        );
        this.setState({
            pattern_constraints: [...this.state.pattern_constraints, new_pattern_constraint_add],
        });
    };

    render() {

        let pattern_constraints_input_element= (
            <React.Fragment>
                <dd className="col-sm-9">
                    <PatternConstraintInput
                        pattern_constraints={this.state.pattern_constraints}
                        pattern_constraint_filter={this.state.selected_pattern_constraints.map(constraint => constraint.constraint_id)}
                        patternConstraintsUpdate={this.props.patternConstraintsUpdate}
                        updatePage={this.props.updatePage}
                        closePatternDetails={this.props.closePatternDetails}
                    />
                </dd>
                <dt className="col-sm-3"></dt>
            </React.Fragment>
        )

        let new_pattern_constraint_jsx = '';
        if (this.state.new_pattern_constraint === true) {
            new_pattern_constraint_jsx = (<NewPatternConstraint
                pattern_constraints={this.state.pattern_constraints}
                newPatternConstraintToggle={this.newPatternConstraintToggle}
                onNewPatternConstraint={this.newPatternConstraintsHandler}
                token={this.props.token}
                userId={this.props.userId}
            />);
        }

        return (
            <dl className="row">
                <dt className="col-sm-3"><label>Constraints</label></dt>
                {pattern_constraints_input_element}
                {new_pattern_constraint_jsx}
                {!this.state.new_pattern_constraint ? <dd className="col-sm-9" style={{display: "inline-flex", justifyContent: "right"}}>
                    <span>
                        Enter New Constraint: <AddCircleOutlineIcon
                                onClick={this.newPatternConstraintToggle}
                                className={classes.AddButton}
                            />
                    </span>
                </dd> : ''}
            </dl>
        );
    }
}

export default PatternConstraintsInput;